import { useContext } from "react";
import { getIn } from "formik";

import { GenerationFormContext } from "../context";

export const useGenerationForm = (fieldPath: string = "") => {
  const context = useContext(GenerationFormContext);
  if (!context) {
    throw new Error(
      "useGenerationForm must be used within a GenerationFormProvider"
    );
  }

  // Calculate field-specific data based on fieldPath
  const fieldValues = getIn(context.form.values, fieldPath) || {};
  const fieldErrors = getIn(context.form.errors, fieldPath) || {};
  const fieldTouches = getIn(context.form.touched, fieldPath) || {};

  // Create field-specific handlers
  const handleChange = (name: string, value: any) => {
    const fullPath = fieldPath ? `${fieldPath}.${name}` : name;
    context.form.setFieldValue(fullPath, value);
  };

  const handleBlur = (name: string) => {
    const fullPath = fieldPath ? `${fieldPath}.${name}` : name;
    context.form.setFieldTouched(fullPath, true);
  };

  return {
    ...context,
    fieldValues,
    fieldErrors,
    fieldTouches,
    handleChange,
    handleBlur,
  };
};
